export function fittedFontSize(region, text) {
  const width = Math.max(0.02, region.bbox[2] - region.bbox[0]);
  const height = Math.max(0.025, region.bbox[3] - region.bbox[1]);
  const density = Math.max(1, String(text || '').length / Math.max(width * 90, 1));
  return Math.max(9, Math.min(28, (height * 720) / Math.sqrt(density)));
}

export function isRtl(region, text) {
  return region.script === 'Arabic' || /[\u0590-\u08ff]/.test(text || '');
}
